<template>
  <!-- 看板 -->
  <div class="sourceMaterial">
    <div class="top_center">
      <!-- <div class="sz30 font_bo mb10">文件资源管理(demo数据)</div> -->
      <div class="mb10">本页展示为Demo数据</div>
      <div class="titiles flex w100 baff ru5 mb20 ">
        <div class="cursor " :class="tabstuts == 1 ? 'bor6es':''" @click="tabcli(1)">文字</div>
        <div class="cursor" :class="tabstuts == 2 ? 'bor6es':''" @click="tabcli(2)">图片</div>
        <div class="cursor" :class="tabstuts == 3 ? 'bor6es':''" @click="tabcli(3)">折扣</div>
      </div>
      <div v-show="tabstuts == 1">
        <textle></textle>
      </div>
    </div>
  </div>
</template>
<script>
import textle from "./indexhome/text.vue"
export default {
  components: {
    textle
  },
  data() {
    return {
      validParam: localStorage.getItem('validParam'),
      tabstuts: 1,
    }
  },
  mounted() {
    // if (this.validParam != 'scgl') {
    //   this.$bus.$emit('showNopermiss',true)
    // }
  },
  methods: {
    tabcli(e) {
      this.tabstuts = e
    }
  }
}
    </script>
    <style lang="less" scoped>
.sourceMaterial {
  padding-top: 69px;
  // padding-left: 10%;
  box-sizing: border-box;
}
.top_center {
  padding-top: 30px;
  .titiles {
    height: 50px;
    box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.05);
    align-items: center;
    padding-left: 30px;
    div {
      margin-right: 128px;
      height: 100%;
      font-size: 16px;
      line-height: 50px;
      position: relative;
    }
    .bor6es::before {
      content: "";
      width: 100%;
      height: 2px;
      background: #be3c6e;
      position: absolute;
      left: 0;
      bottom: 10px;
      border-radius: 21px;
    }
  }
}
@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;
  }
}
@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}
</style>
    <style lang="less">
</style>